<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      志愿管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>

      </div>
      <div class="padding-bottom-sm">
        <el-radio-group v-model="volunteerType">
          <el-radio-button :label="item.type" v-for="item in volunteerTypes" :key="item.type">{{
              item.name
            }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="table-warpper">
        <el-table
            :data="volunteerList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="学生姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所在院校">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.org_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所在年级">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.class_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300px">
            <template slot-scope="scope" >
              <div v-if="scope.row.status === -4" class="table-operate margin-bottom-xs">
                <el-button
                    size="medium"
                    type="primary"
                    @click="showItem(scope.row.stu_id,scope.row.file_id)"
                >查看详情
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                >已拒绝
                </el-button>
              </div>
              <div v-else>
                <div class="table-operate margin-bottom-xs">
                  <el-button
                      size="medium"
                      type="primary"
                      @click="showItem(scope.row.stu_id,scope.row.file_id)"
                  >查看详情
                  </el-button>
                  <el-button
                      size="medium"
                      type="primary"
                      @click="setItemInfo(scope.row)"
                  > {{ scope.row.mian_type === 0 ? '发送面试邀请' : '查看面试邀请' }}
                  </el-button>
                </div>
                <div class="table-operate" >
                  <el-button
                      v-if="Number(scope.row.mian_type) > 0"
                      size="medium"
                      type="primary"
                      @click="setItemEmploy(scope.row)"
                  >录用
                  </el-button>
                  <el-button
                      size="medium"
                      type="danger"
                      @click="setItemStatus(scope.row.zy_id)"
                  >拒绝
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="volunteerList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            @current-change="getList"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <stu-dialog :subdialogDialog="dialog" :setId="setId" :file="file" @cancelDialog="cancelDialog"/>
    <el-dialog
        :title="'拒绝原因'"
        :visible.sync="dialog2"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="setForm" :rules="rules" ref="setForm">
        <el-form-item label="" prop="name">
          <el-input type="textarea" v-model="setForm.name" placeholder="请输入拒绝原因" rows="5"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="cancelDialog">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('setForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="面试邀请"
        :visible.sync="dialog3"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <div class="flex align-center justify-between student-info" v-if="setItem">
        <b>{{ setItem.stu_name }}</b>
        <i>联系电话：{{ setItem.phone }}</i>
      </div>
      <h3 class="margin-bottom" style="color: #009787;font-size: 18px">面试详情</h3>
      <el-form :model="interviewForm" :rules="interviewRules" ref="interviewForm" label-width="100px" v-if="setItem">
        <el-form-item label="面试时间" prop="time">
          <el-date-picker
              :disabled="setItem.mian_type !== 0"
              style="width: 100%;"
              v-model="interviewForm.time"
              align="right"
              type="date"
              placeholder="请选择到期时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="面试方式" prop="type">
          <el-radio-group v-model="interviewForm.type" :disabled="setItem.mian_type !== 0">
            <el-radio v-for="item in interviewType" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="面试备注" prop="desc">
          <el-input :disabled="setItem.mian_type !== 0" type="textarea" v-model="interviewForm.desc"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0" v-if="setItem.mian_type === 0">
          <el-button class="padding-lr-xl" @click="cancelDialog">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="interviewSubmitForm('interviewForm')">提交</el-button>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0" v-else>
          <el-button class="padding-lr-xl" type="primary" @click="cancelDialog">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        title="录用"
        :visible.sync="dialog4"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <div class="flex align-center justify-between student-info" v-if="setItem">
        <b>{{ setItem.stu_name }}</b>
        <i>联系电话：{{ setItem.phone }}</i>
      </div>
      <h3 class="margin-bottom" style="color: #009787;font-size: 18px">录用信息</h3>
      <el-form :model="employForm" :rules="employRules" ref="employForm" label-width="120px">
        <el-form-item label="报道时间" prop="bd_time">
          <el-date-picker
              style="width: 100%;"
              v-model="employForm.bd_time"
              align="right"
              type="datetime"
              placeholder="请选择到期时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实习时间" prop="start_date">
          <el-date-picker
              style="width: 100%;"
              v-model="employForm.start_date"
              type="daterange"
              range-separator="至"
              :picker-options="pickerOptions1"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报到地点" prop="address">
          <el-input v-model="employForm.address"></el-input>
        </el-form-item>
        <el-form-item label="报到联系人" prop="contact_name">
          <el-input v-model="employForm.contact_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="contact_phone">
          <el-input v-model="employForm.contact_phone"></el-input>
        </el-form-item>
        <el-form-item label="所需材料" prop="cailiao">
          <el-input type="textarea" v-model="employForm.cailiao"></el-input>
        </el-form-item>
        <el-form-item label="其他注意事项" prop="qita">
          <el-input type="textarea" v-model="employForm.qita"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="cancelDialog">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm4('employForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import {addInvite, volunteerEmploy, volunteerList, volunteerState} from "@/api/practiceBase";
import stuDialog from "@/views/coordinate/page/dialog/stuDialog";
import {interviewType, optionList} from "@/tools/utils";

export default {
  name: "volunteer",
  data() {
    return {
      interviewType: optionList(false, interviewType),
      volunteerTypes: [
        {type: 1, name: '第一志愿'},
        {type: 2, name: '第二志愿'},
        {type: 3, name: '第三志愿'}
      ],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      volunteerType: 1,
      stu_name: "",
      volunteerList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      file: '',
      setItem: null,
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      setForm: {name: ''},
      rules: {name: [{required: true, message: '请输入拒绝原因', trigger: 'blur'}]},
      interviewForm: {
        time: null,
        type: 1,
        desc: '',
      },
      interviewRules: {
        time: [{type: 'date', required: true, message: '请选择面试日期', trigger: 'change'}],
        type: [{required: true, message: '请选择面试类型', trigger: 'change'}],
        // desc: [{required: true, message: '请输入面试备注', trigger: 'blur'}]
      },
      employForm: {
        bd_time: null,
        start_date: null,
        address: '',
        contact_name: '',
        contact_phone: '',
        cailiao: '',
        qita: '',
      },
      employRules: {
        bd_time: [{type: 'date', required: true, message: '请选择报道日期', trigger: 'change'}],
        start_date: [{ required: true, message: '请选择实习日期', trigger: 'change'}],
        address: [{required: true, message: '请输入报道地址', trigger: 'blur'}],
        contact_name: [{required: true, message: '请输入报道联系人', trigger: 'blur'}],
        contact_phone: [{required: true, message: '请输入联系人电话', trigger: 'blur'}],
        cailiao: [{required: true, message: '请输入所需材料', trigger: 'blur'}],
        qita: [{required: true, message: '请输入其他注意事项', trigger: 'blur'}],
      }
    }
  },
  components: {stuDialog},
  created() {
    this.$emit(
        "setIndex",
        '/practiceBase/practiceBaseList',
        "当前位置：岗位管理 - 实习岗位管理 - 志愿管理",
        true
    );
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await volunteerList(this.$route.query.id, this.volunteerType, this.stu_name, this.page, this.limit)
      this.volunteerList = _list.data.list
      this.total = _list.data.count
    },
    //  显示发送面试邀请
    setItemInfo(item) {
      this.setItem = item
      this.dialog3 = true
      if (item.mian_type !== 0) {
        this.interviewForm = {
          time: new Date(item.mian_time * 1000),
          type: item.mian_type,
          desc: item.mian_remark,
        }
      }
    },

    //  搜索
    onSearch() {
      this.page = 1
      this.getList()
    },
    //  显示学生详情
    showItem(id, file) {
      this.setId = id
      this.file = file
      this.dialog = true

    },
    //  关闭弹框
    cancelDialog() {
      this.setId = 0
      this.dialog = false
      this.dialog2 = false
      this.dialog3 = false
      this.dialog4 = false
      this.setItem = null
    },
    //  显示录用表单
    setItemEmploy(obj) {
      this.setId = obj.zy_id
      this.setItem = obj
      this.dialog4 = true
    },
    //  确认录用
    submitForm4(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData4(formName)
        }
      });
    },
    async submitData4(formName) {
      let _state = await volunteerEmploy(2,this.setId,  '',
          this.$tools.ZHDate(new Date(this.employForm.bd_time),1),
          this.$tools.ZHDate(new Date(this.employForm.start_date[0])),
          this.$tools.ZHDate(new Date(this.employForm.start_date[1])),
          this.employForm.address,
          this.employForm.contact_name,
          this.employForm.contact_phone,
          this.employForm.cailiao,
          this.employForm.qita,
      );
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.cancelDialog()
      this.getList()
    },

    //  拒绝提示
    setItemStatus(id) {
      this.$confirm("确定要拒绝吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.setId = id
        this.dialog2 = true
      });
    },
    //  填写拒绝原因
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    //  确认拒绝
    async submitData(formName) {
      let _state = await volunteerState(this.setId, -4, this.setForm.name);
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.cancelDialog()
      this.getList()
    },
    //  邀请面试
    interviewSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData2(formName)
        }
      });
    },
    async submitData2(formName) {
      let _state = await addInvite(this.setItem.zy_id, this.$tools.ZHDate(new Date(this.interviewForm.time)), this.interviewForm.type, this.interviewForm.desc);
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.dialog3 = false
      this.getList()
    }
  },
  watch: {
    volunteerType() {
      this.page = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
.student-info {
  padding: 20px 0;
  margin-bottom: 20px;
  border-bottom: 1px dashed #aaa;

  b {
    font-size: 18px;
    color: #009787;
  }

  i {
    font-size: 16px;
  }
}
</style>